import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectWithoutProperties from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createSuper";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import BaseMap from './BaseMap';
import MapLoader from './MapLoader';
var DMapEngine = /*#__PURE__*/function (_BaseMap) {
  _inherits(DMapEngine, _BaseMap);
  var _super = _createSuper(DMapEngine);
  function DMapEngine() {
    _classCallCheck(this, DMapEngine);
    return _super.apply(this, arguments);
  }
  _createClass(DMapEngine, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var options,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.prev = 1;
                _context.next = 4;
                return MapLoader.load('dmap');
              case 4:
                this.map = new window.DMap.Map({
                  container: this.containerId,
                  style: 'dimap://styles/normal',
                  center: options.center || [118.180987, 24.486432],
                  zoom: options.zoom || 10
                });
                this.layersMap = new Map();
                return _context.abrupt("return", this.map);
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                console.log('AutoConsole ~ DMapEngine ~ init ~ error:', _context.t0);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "createLngLatInstance",
    value: function createLngLatInstance(lng, lat) {
      return new window.DMap.LngLat(lng, lat);
    }
  }, {
    key: "createCity",
    value: function createCity(item) {
      // 滴滴地图使用城市名称
      return item.name;
    }
  }, {
    key: "reverseAddressFromLngLat",
    value: function reverseAddressFromLngLat(lng, lat) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve) {
          var geocoder, _yield$geocoder$rever, _yield$geocoder$rever2, err, res, _res$results$;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  geocoder = new window.DMap.GeoCodeService();
                  _context2.next = 3;
                  return geocoder.reverseGeoCode({
                    location: "".concat(lng, ",").concat(lat)
                  });
                case 3:
                  _yield$geocoder$rever = _context2.sent;
                  _yield$geocoder$rever2 = _slicedToArray(_yield$geocoder$rever, 2);
                  err = _yield$geocoder$rever2[0];
                  res = _yield$geocoder$rever2[1];
                  if (res.status === 10000) {
                    resolve({
                      address: (_res$results$ = res.results[0]) === null || _res$results$ === void 0 ? void 0 : _res$results$.address_all,
                      addressComponent: res.results[0]
                    });
                  } else {
                    resolve({
                      address: '',
                      addressComponent: {}
                    });
                  }
                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "createGeolocation",
    value: function createGeolocation(options) {
      var getCurrentPosition = function getCurrentPosition(callback) {
        return window.DMap.getGeoLocation({
          success: function success(e) {
            var status = e.coords ? 'complete' : 'error';
            if (e.coords) {
              var location = e.coords;
              var result = {
                position: {
                  lat: location.latitude,
                  lng: location.longitude,
                  getLat: function getLat() {
                    return location.latitude;
                  },
                  getLng: function getLng() {
                    return location.longitude;
                  }
                }
              };
              callback(status, result);
            } else {
              callback(status, {});
            }
          },
          error: function error() {
            callback('error', {});
          }
        });
      };
      return {
        getCurrentPositionFix: getCurrentPosition
      };
    }
  }, {
    key: "creaeteDistrictSearch",
    value: function creaeteDistrictSearch(options) {
      return {
        search: function search() {}
      };
      // return new window.DMap.DistrictSearch(options)
    }
  }, {
    key: "setFitView",
    value: function setFitView() {
      // this.map.setFitView()
      return this;
    }
  }, {
    key: "panTo",
    value: function panTo(position) {
      this.map.panTo(this.createLngLatInstance.apply(this, _toConsumableArray(position)));
      return this;
    }
  }, {
    key: "clearInfoWindow",
    value: function clearInfoWindow() {
      this.map.clearInfoWindow();
      return this;
    }
  }, {
    key: "clearMap",
    value: function clearMap() {
      var _this = this;
      this.layersMap.forEach(function (layer) {
        layer.remove();
        _this.layersMap.delete(layer);
      });
      return this;
    }
  }, {
    key: "removeOverLay",
    value: function removeOverLay(marker) {
      marker.remove();
      return this;
    }
  }, {
    key: "addOverLay",
    value: function addOverLay(marker) {
      marker.addTo(this.map);
      this.layersMap.set(marker, marker);
      // this.map.addLayer(marker)
      return this;
    }
  }, {
    key: "createMarker",
    value: function createMarker(options) {
      var map = options.map,
        position = options.position,
        others = _objectWithoutProperties(options, ["map", "position"]);
      var div = document.createElement('div');
      var img = document.createElement('img');
      img.src = options.icon;
      img.style.width = '100%';
      img.style.height = '100%';
      div.appendChild(img);
      var marker = new window.DMap.Marker(div);
      if (position) {
        marker.setLngLat(this.createLngLatInstance.apply(this, _toConsumableArray(position)));
      }
      if (map) {
        img.onload = function () {
          marker.addTo(map);
        };
      }
      marker.setPosition = function (lnglat) {
        marker.setLngLat(lnglat);
      };
      return marker;
    }
  }, {
    key: "createPlaceSearch",
    value: function createPlaceSearch(options) {
      var poiService = new window.DMap.PoiService();
      poiService.search = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(keyword, func) {
          var _yield$poiService$tex, _yield$poiService$tex2, err, res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return poiService.textSearch({
                    // city: options.city,
                    keywords: keyword
                  });
                case 2:
                  _yield$poiService$tex = _context3.sent;
                  _yield$poiService$tex2 = _slicedToArray(_yield$poiService$tex, 2);
                  err = _yield$poiService$tex2[0];
                  res = _yield$poiService$tex2[1];
                  if (res.status === 10000) {
                    func('complete', {
                      info: 'OK',
                      poiList: {
                        pois: res.results
                      }
                    });
                  } else {
                    func('error', {});
                  }
                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }();
      return poiService;
    }
  }, {
    key: "createGeocoder",
    value: function createGeocoder(options) {
      var geocoder = new window.DMap.GeoCodeService();
      geocoder.getAddress = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(center, callback) {
          var _yield$geocoder$rever3, _yield$geocoder$rever4, err, res, status, _res$results$2, result;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return geocoder.reverseGeoCode({
                    location: "".concat(center[0], ",").concat(center[1])
                  });
                case 2:
                  _yield$geocoder$rever3 = _context4.sent;
                  _yield$geocoder$rever4 = _slicedToArray(_yield$geocoder$rever3, 2);
                  err = _yield$geocoder$rever4[0];
                  res = _yield$geocoder$rever4[1];
                  status = res.status === 10000 ? 'complete' : 'error';
                  if (res.status === 10000) {
                    result = {
                      info: 'OK',
                      regeocode: {
                        formattedAddress: (_res$results$2 = res.results[0]) === null || _res$results$2 === void 0 ? void 0 : _res$results$2.address_all
                      }
                    };
                    callback(status, result);
                  } else {
                    callback(status, {
                      info: 'error'
                    });
                  }
                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
        return function (_x4, _x5) {
          return _ref3.apply(this, arguments);
        };
      }();
      geocoder.getPoint = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(address, callback) {
          var _yield$geocoder$geoCo, _yield$geocoder$geoCo2, err, res, obj;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return geocoder.geoCode({
                    address: address
                  });
                case 2:
                  _yield$geocoder$geoCo = _context5.sent;
                  _yield$geocoder$geoCo2 = _slicedToArray(_yield$geocoder$geoCo, 2);
                  err = _yield$geocoder$geoCo2[0];
                  res = _yield$geocoder$geoCo2[1];
                  if (res.status === 10000) {
                    obj = {
                      status: '0',
                      location: {
                        lon: res.results.geocodes[0].location.lng,
                        lat: res.results.geocodes[0].location.lat
                      }
                    };
                    callback(obj);
                  } else {
                    callback({
                      status: 'error'
                    });
                  }
                case 7:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
        return function (_x6, _x7) {
          return _ref4.apply(this, arguments);
        };
      }();
      return geocoder;
    }
  }, {
    key: "createInfoWindow",
    value: function createInfoWindow(options) {
      var _this2 = this;
      var infoWindow = new window.DMap.Popup();
      infoWindow.open = function (map, center) {
        infoWindow.setLngLat(center).addTo(map);
      };
      infoWindow.setContent = function (content) {
        infoWindow.setHTML(content);
      };
      infoWindow.close = function () {
        _this2.map.removeOverLay(infoWindow);
      };
      return infoWindow;
    }
  }, {
    key: "createPixel",
    value: function createPixel(x, y) {
      return new window.DMap.Point(x, y);
    }
  }, {
    key: "createIcon",
    value: function createIcon(options) {
      return new window.DMap.Icon(options);
    }
  }, {
    key: "createSize",
    value: function createSize(x, y) {
      return new window.DMap.Point(x, y);
    }
  }, {
    key: "openInfoWindow",
    value: function openInfoWindow(marker, infoWindow) {
      infoWindow.open(this.map, marker.getPosition());
    }
  }, {
    key: "createPolygon",
    value: function createPolygon(options) {
      return new window.DMap.PolygonLayer(options);
    }
  }, {
    key: "on",
    value: function on(target, eventName, handler) {
      var wrappedHandler = function wrappedHandler(e) {
        e.lnglat = {
          getLng: function getLng() {
            return e.lngLat.lng;
          },
          getLat: function getLat() {
            return e.lngLat.lat;
          }
        };
        handler(e);
      };
      this._eventMap.set(handler, wrappedHandler);
      if (target && target.on) {
        target.on(eventName, wrappedHandler);
      } else {
        console.error("target ".concat(target, " is not a valid event emitter"));
      }
    }
  }, {
    key: "off",
    value: function off(target, eventName, handler) {
      var wrapped = this._eventMap.get(handler);
      if (wrapped) {
        target.off(eventName, wrapped);
        this._eventMap.delete(handler);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.map && this.map.destroy();
    }
  }]);
  return DMapEngine;
}(BaseMap);
export { DMapEngine as default };